import type { FC } from "react";
import type { ISiteItem } from "app/pages/website-analysis/audience-overlap/SharedVisitorsTable/sharedTypes";
import { colorsPalettes } from "@similarweb/styles";
import type { ISitesTabsProps } from "./SiteTabs.types";
import { SiteTab } from "./SiteTab";
import { SiteTabsContainer } from "./SiteTabs.styles";

const { carbon } = colorsPalettes;

export const SiteTabs: FC<ISitesTabsProps> = (props) => {
    const { siteItems, selectedIndex, onTabClickCallback } = props;
    const onTabClick = (tabIndex) => () => onTabClickCallback(tabIndex);
    const renderSiteTab = (siteItem: ISiteItem, index) => {
        const { displayText, color, isAutoSuggest } = siteItem;
        const isSelected = index === selectedIndex;
        return (
            <SiteTab
                key={displayText}
                color={color}
                isSelected={isSelected}
                onClick={onTabClick(index)}
                site={displayText}
                setOpacity={isAutoSuggest}
            />
        );
    };
    return <SiteTabsContainer>{siteItems.map(renderSiteTab)}</SiteTabsContainer>;
};
